export default __webpack_public_path__ + "static/media/dealedge_trophy.5387cf81.jpg";